import { Component, ChangeDetectionStrategy, input, output, computed, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';
import { priceLimit } from '../../shared/config/constants';
import { Estimate, VendorOrder } from '../../shared/models/vendor-order.model';
import {
  SelectQuoteModalComponent,
  SelectQuoteModalData,
  SelectQuoteModalResult,
} from '../../core/layout/pages/translation-manager/quotes/select-quote-modal/select-quote-modal.component';

export interface VendorSelectData {
  jobUid: string;
  customJobName?: string;
  vendorId: string;
  vendorName: string;
  hasLowestRate: boolean;
}

@Component({
  selector: 'app-vendor-select-btn',
  imports: [TranslatePipe],
  templateUrl: './vendor-select-btn.component.html',
  styleUrl: './vendor-select-btn.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VendorSelectBtnComponent {
  private readonly dialog = inject(MatDialog);

  readonly order = input.required<VendorOrder>();
  readonly estimate = input.required<Estimate>();
  readonly hasLowestRate = input(false);
  readonly quoteConfirmed = output<string>();

  readonly priceLimitMax = priceLimit.max;

  readonly showWarning = computed(() => {
    const o = this.order();
    const e = this.estimate();
    return !!o.specialistTranslationRequirement || (e.priceMax ?? 0) > this.priceLimitMax;
  });

  readonly showButton = computed(() => {
    const e = this.estimate();
    return !!e.priceMax && e.jobStatus === 'AWAITING_VENDOR_SELECTION';
  });

  openSelectQuoteModal(): void {
    const modalData: SelectQuoteModalData = {
      order: this.order(),
      estimate: this.estimate(),
      hasLowestRate: this.hasLowestRate(),
    };

    const dialogRef = this.dialog.open(SelectQuoteModalComponent, {
      data: modalData,
      width: '622px',
      maxWidth: '95vw',
      panelClass: 'no-padding-dialog',
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result: SelectQuoteModalResult | undefined) => {
      if (result?.action === 'confirmed') {
        this.quoteConfirmed.emit(result.jobUid);
      }
    });
  }
}
